/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class PreparationField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    return (
      <Form.Field required>
        <label>Preparation Time</label>
        <Input
          label={{ content: 'min' }}
          labelPosition="right"
          placeholder="e.g 15"
          type="number"
          min="5"
          max="120"
          required
          onChange={e => onChange('cooking_duration', e.target.value)}
          value={value}
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/preparationField.js